module.exports = __webpack_public_path__ + "media/images/massage/malika@2x-86855eef33975e066d15c4d516fe5983.jpg";